import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withState } from 'recompose';

import CircularProgress from '@mui/material/CircularProgress';
import Button from 'components/Common/Buttons/ButtonV2';
import v from 'components/variables';

@withState('busy', 'setBusy', false)
export default class BusyButton extends Component {
  render() {
    const {
      busy,
      setBusy,
      text,
      busyText,
      onClick,
      children,
      render,
      hideSpinner,
      onActionComplete,
      ...rest
    } = this.props;
    const { variant, color, disabled } = rest;

    const colorMap = {
      primary: v.green,
      secondary: v.blue,
      error: v.grenadier,
    };

    let spinnerColor = v.grayDark;
    if (variant === 'filled') {
      spinnerColor = v.white;
    } else if (color) {
      spinnerColor = colorMap[color];
    }

    return (
      <Button
        disabled={disabled}
        onClick={async () => {
          if (busy) return;
          setBusy(true);
          await onClick();
          setBusy(false);
          onActionComplete();
        }}
        {...rest}
      >
        {(() => {
          if (children)
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {busy && !hideSpinner && (
                  <CircularProgress
                    size={20}
                    style={{
                      marginRight: 4,
                      color: spinnerColor,
                    }}
                  />
                )}
                {children}
              </div>
            );
          if (render) return <>{render(busy)}</>;
          return busy ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {!hideSpinner && (
                <CircularProgress
                  size={20}
                  style={{
                    marginRight: 4,
                    color: spinnerColor,
                  }}
                />
              )}
              {busyText}
            </div>
          ) : (
            <>{text}</>
          );
        })()}
      </Button>
    );
  }
}

BusyButton.propTypes = {
  /** Determine if the button is in the "busy" state. */
  busy: PropTypes.bool.isRequired,

  /** Function to set the button as busy. */
  setBusy: PropTypes.func.isRequired,

  /** Text to display in the button when not busy. */
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Text to display in the button when busy. */
  busyText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Custom click event. */
  onClick: PropTypes.func.isRequired,

  /** Action to take after the buttons click event has been processed. */
  onActionComplete: PropTypes.func,

  /** Special render function to override default render. */
  render: PropTypes.func,

  /** Determine if the spinner should be hidden when in busy state. */
  hideSpinner: PropTypes.bool,

  children: PropTypes.node,
};

BusyButton.defaultProps = {
  children: null,
  render: null,
  text: '',
  busyText: '',
  hideSpinner: false,
  onActionComplete: () => {},
};
